import { ICON_SRC_PREFIX } from '@ayn-ui/lib/modules';
import { Provider } from '@angular/core';

export const ICON_SRC_PROVIDER: Provider = { provide: ICON_SRC_PREFIX, useValue: '/assets/images/icons/' };
